import React, { useState } from "react";
import Swiper from "react-id-swiper";
import "swiper/css/swiper.css";
const SliderOne = () => {
  const [swiper, setSwiper] = useState(null);

  const goNext = () => {
    if (swiper !== null) {
      swiper.slideNext();
    }
  };

  const goPrev = () => {
    if (swiper !== null) {
      swiper.slidePrev();
    }
  };

  return (
    <div className="banner-wrapper">
      <section className="banner-one banner-carousel__one no-dots">
        <Swiper getSwiper={setSwiper}>
        <div className="banner-one__slide">
        {/* <div className="banner-one__slide banner-one__slide-one"> */}
            <div className="container">
              <div className="banner-one__bubble-1"></div>
              <div className="banner-one__bubble-2"></div>
              <div className="banner-one__bubble-3"></div>
              {/* <img src={slidestrech} alt="" className="banner-one__scratch" /> */}
              {/* <img src={person1} className="banner-one__person" alt="" /> */}
              <div className="row no-gutters">
                <div className="col-xl-12">
                  <h5 className="banner-one__title banner-one__light-color">
                    苏州卫捷 <br />
                    PIVAS LEADER
                  </h5>
                  <span style={{fontSize:20,color:"white"}}>输液分拣机、输液贴签机、针剂存储/统排机</span>
                  {/* <p className="banner-one__tag-line">
                    are you ready to learn?
                  </p>
                  <a href="#none" className="thm-btn banner-one__btn">
                    Learn More
                  </a> */}
                </div>
              </div>
            </div>
          </div>
          {/* <div className="banner-one__slide banner-one__slide-two">
            <div className="container">
              <div className="banner-one__bubble-1"></div>
              <div className="banner-one__bubble-2"></div>
              <div className="banner-one__bubble-3"></div>
              <img src={slidestrech} alt="" className="banner-one__scratch" />
              <img src={person2} className="banner-one__person" alt="" />
              <div className="row no-gutters">
                <div className="col-xl-12">
                  <h3 className="banner-one__title banner-one__light-color">
                    苏州 <br />
                    卫捷医药科技
                  </h3>
                  <p className="banner-one__tag-line">
                    are you ready to learn?
                  </p>
                  <a href="#none" className="thm-btn banner-one__btn">
                    Learn More
                  </a>
                </div>
              </div>
            </div>
          </div> */}
        </Swiper>
      </section>
      <div className="banner-carousel-btn">
        <div
          onClick={goPrev}
          onKeyUp={goPrev}
          tabIndex={0}
          role="button"
          className="banner-carousel-btn__left-btn banner-arrow"
        >
          <i className="kipso-icon-left-arrow"></i>
        </div>
        <div
          onClick={goNext}
          onKeyDown={goNext}
          role="button"
          tabIndex={0}
          className="banner-carousel-btn__right-btn banner-arrow"
        >
          <i className="kipso-icon-right-arrow"></i>
        </div>
      </div>
      {/* <div className="banner-one__cta"> */}
        {/* <div className="banner-one__cta-icon">
          <i className="kipso-icon-black-graduation-cap-tool-of-university-student-for-head"></i>
        </div>
        <div className="banner-one__cta-title">
          <h3 className="banner-one__cta-text">
            <a href="#none">Read how we encourage our students to learn</a>
          </h3>
        </div>
        <div className="banner-one__cta-link">
          <a href="#none">
            <i className="kipso-icon-right-arrow"></i>
          </a>
        </div>
      </div> */}
    </div>
  );
};
export default SliderOne;
